<template>
  <div>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text>Etes-vous sûr(e) de vouloir effacer cette signature ?</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn round flat @click="dialog = false">Annuler</v-btn>
        <v-btn round dark color="pink darken-1 elevation-2" @click="process">Effacer</v-btn>
      </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      top
      color="green accent-4"
      multi-line
      v-model="clearSuccess">
      La signature a été effacée avec succès
    </v-snackbar>
  </div>
</template>

<script>
  export default {
    name: 'ClearSignatureDialog',
    data () {
      return {
        dialog: false,
        clearSuccess: false
      }
    },
    props: {
      'signature-reference': {
        type: String
      },
      title: {
        type: String
      }
    },
    methods: {
      process () {
        this.$parent.$refs[this.signatureReference].clear()
        this.dialog = false
        this.clearSuccess = true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Report/ClearSignatureDialog.vue